import { FC } from "react";
import { useTranslation } from "react-i18next";
import { setModalsData, TModalsState } from "../../../api/store/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { AdminFormFieldSubmit } from "../../../components/admin/formFields";
import { useLazyGetDiagnoseDeviceQuery } from "../../../api/network/vmApiService";
import { toast } from "react-toastify";
import svgIcons from "../../../assets/svg/svgIcons";

type ModalDiagnoseCameraProps = {
  cameraId: string;
};

const ModalDiagnoseCamera: FC<ModalDiagnoseCameraProps> = ({ cameraId }) => {
  const { t: tMain } = useTranslation();
  const { t } = useTranslation("translation", {
    keyPrefix:
      "camera.dashboard.management.cameras.camera_details.tabs.overview",
  });
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );
  const dispatch = useDispatch();

  const [diagnoseApiTrigger, { isLoading: isLoadingDiagnostic }] =
    useLazyGetDiagnoseDeviceQuery();

  const hideModal = () => {
    dispatch(setModalsData({ ...modalsState, showModalDiagnoseCamera: false }));
  };

  const handleSubmit = () => {
    diagnoseApiTrigger(cameraId)
      .then((resposne: any) => {
        toast.success(
          // "You Will Be Notified When New Results Updated. After being notified, you need to reload the page to watch new results."
          "The diagnostic request has been received. Please check back later."
        );
        hideModal();
      })
      .catch((error) => {
        toast.error("Error Diagnosing", error);
      });
  };

  if (modalsState.showModalDiagnoseCamera === false) return null;
  return (
    <>
      <div
        className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay"
        onClick={hideModal}
      ></div>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none z-modal">
        <div className="relative my-6 mx-auto max-w-[calc(100vw-4rem)] w-[480px] z-modal">
          <form
            className="p-8 bg-white grid grid-cols-6 gap-6 rounded-3xl shadow-2xl"
            onSubmit={handleSubmit}
          >
            <h2 className="col-span-6 text-3xl font-bold text-heading-black">
              {t("diagnose_heading")}
            </h2>
            <p className="col-span-6 mt-0 leading-relaxed text-gray-500">
              {t("diagnose_sub_heading")}
            </p>
            <AdminFormFieldSubmit
              label={
                isLoadingDiagnostic ? (
                  <img
                    src={svgIcons.LoadingAnimation}
                    alt="Loading animation"
                    className={`size-10`}
                  />
                ) : (
                  t("stop_reboot")
                )
              }
              type="button"
              variant="primary"
              disabled={isLoadingDiagnostic}
              onClick={handleSubmit}
            />

            <AdminFormFieldSubmit
              label={tMain("cancel")}
              type="button"
              variant="danger-transparent"
              onClick={hideModal}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default ModalDiagnoseCamera;
